export const enum EVENT_STATUS {
    Scheduled = 'scheduled',
    Open = 'open',
    Closed = 'closed'
}
